export default {
  namespaced: true,
  state: {
    charity: null,
    wallet: null,
    amount: 25,
    wallets: [{
      name: 'HV Donations',
      amount: 25
    }, {
      name: 'HVT Wallet',
      amount: 100
    }]
  },
  getters: {
  },
  mutations: {
    setAmount (state, amount) {
      state.amount = amount
    },
    setCharity (state, charity) {
      state.charity = charity
    },
    setWallet (state, wallet) {
      state.wallet = wallet
    },
    resetData (state) {
      state.wallet = null
      state.amount = 25
      state.charity = null
    }
  },
  actions: {
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/donation-form.js